export enum AlertSeverityEnum {
  error = 'error',
  info = 'info',
  success = 'success',
  warning = 'warning',
}
